export function normalizeToString(value: string | string[] | null): string {
    if (!value) return '';
    if (Array.isArray(value)) return value[0];
    return value;
}

export function normalizeToNumber(value: string | string[] | null): number {
    const str = normalizeToString(value);
    const n = Number(str);
    return isNaN(n) ? 0 : n;
}